export const fr = {
  causeAwarenessDates: {
    national_blood_donor_month: 'Mois national du don de sang',
    mentoring_month: 'Mois du mentorat',
    international_day_education: "Journée internationale de l'éducation",
    black_history_month: "Mois de l'histoire des Noirs",
    world_cancer_day: 'Journée mondiale contre le cancer',
    international_day_women_science:
      'Journée internationale des femmes et des filles de science',
    world_day_social_justice: 'Journée mondiale de la justice sociale',
    womens_history_month: "Mois de l'histoire des femmes",
    national_nutrition_month: 'Mois de la nutrition',
    read_across_america_day: "Journée de la lecture à travers l'Amérique",
    world_wildlife_day: 'Journée mondiale de la vie sauvage',
    international_womens_day: 'Journée internationale des femmes',
    global_recycling_day: 'Journée mondiale du recyclage',
    autism_acceptance_month: "Mois de la sensibilisation à l'autisme",
    world_health_day: 'Journée mondiale de la santé',
    microvolunteering_day: 'Journée du micro-bénévolat',
    national_environmental_education_week:
      "Semaine nationale de l'éducation environnementale",
    national_volunteer_week: 'Semaine nationale du bénévolat',
    earth_day: 'Jour de la Terre',
    speech_hearing_month: "Mois de la parole et de l'audition",
    asian_heritage_month: 'Mois du patrimoine asiatique',
    physical_fitness_month: "Mois national de l'activité physique et du sport",
    mental_health_month: 'Mois de la santé mentale',
    clean_air_month: "Mois de l'air pur",
    mental_health_week: 'Semaine de la santé mentale',
    international_day_families: 'Journée internationale des familles',
    global_accessibility_day:
      "Journée mondiale de la sensibilisation à l'accessibilité",
    world_hunger_day: 'Journée mondiale de la faim',
    lgbt_pride_month: 'Mois de la Fierté LGBT',
    indigenous_history_month: "Mois de l'histoire autochtone",
    canadian_environment_week: "Semaine canadienne de l'environnement",
    world_environment_day: "Journée mondiale de l'environnement",
    national_trails_day: 'Journée nationale des sentiers',
    world_oceans_day: 'Journée mondiale des océans',
    world_blood_donor_day: 'Journée mondiale du don de sang',
    juneteenth: 'Juneteenth',
    world_refugee_day: 'Journée mondiale des réfugiés',
    national_indigenous_peoples_day:
      'Journée nationale des peuples autochtones',
    disabilities_pride_month: 'Mois de la fierté des personnes handicapées',
    clean_beaches_week: 'Semaine des plages propres',
    international_indigenous_peoples_day:
      'Journée internationale des peuples autochtones',
    international_youth_day: 'Journée internationale de la jeunesse',
    world_humanitarian_day: "Journée mondiale de l'aide humanitaire",
    womens_equality_day: "Journée nationale de l'égalité des femmes",
    overdose_awareness_day:
      'Journée internationale de sensibilisation aux surdoses',
    national_recovery_month: 'Mois national du rétablissement',
    international_charity_day: 'Journée internationale de la charité',
    international_literacy_day: "Journée internationale de l'alphabétisation",
    world_suicide_prevention_day:
      'Journée mondiale de la prévention du suicide',
    hispanic_heritage_month: 'Mois du patrimoine hispanique',
    world_cleanup_day: 'Journée mondiale du nettoyage',
    international_peace_day: 'Journée internationale de la paix',
    public_lands_day: 'Journée nationale des terres publiques',
    food_loss_waste_day:
      'Journée internationale de sensibilisation aux pertes et gaspillages alimentaires',
    orange_shirt_day: 'Journée du chandail orange',
    uk_black_history_month: "Mois de l'histoire des Noirs",
    disability_employment_month:
      "Mois national de la sensibilisation à l'emploi des personnes handicapées",
    womens_history_month_ca: "Mois de l'histoire des femmes",
    international_older_persons_day:
      'Journée internationale des personnes âgées',
    world_animal_day: 'Journée mondiale des animaux',
    mental_illness_week: 'Semaine de sensibilisation aux maladies mentales',
    world_habitat_day: "Journée mondiale de l'habitat",
    world_mental_health_day: 'Journée mondiale de la santé mentale',
    international_day_girl: 'Journée internationale de la fille',
    indigenous_peoples_day: 'Journée des peuples autochtones',
    disaster_reduction_day:
      'Journée internationale pour la réduction des risques de catastrophes',
    world_food_day: "Journée mondiale de l'alimentation",
    poverty_eradication_day:
      "Journée internationale pour l'élimination de la pauvreté",
    native_american_heritage_month: 'Mois du patrimoine amérindien',
    homeless_youth_month: 'Mois de sensibilisation aux jeunes sans-abri',
    career_development_month: 'Mois du développement de carrière',
    hunger_homelessness_week:
      'Semaine de sensibilisation à la faim et aux sans-abri',
    philanthropy_day: 'Journée nationale de la philanthropie',
    universal_children_day: "Journée mondiale de l'enfance",
    survivors_suicide_loss_day:
      'Journée internationale des survivants du suicide',
    giving_tuesday: 'Mardi je donne',
    international_day_disabilities:
      'Journée internationale des personnes handicapées',
    international_volunteer_day: 'Journée internationale des bénévoles',
    world_soil_day: 'Journée mondiale des sols',
    human_rights_day: "Journée des droits de l'homme",
  },
}
